<template>
    <div class="admin-content">
        <div class="left-wrapper">
            <el-menu :default-active="adminTab" class="left-nav">
                <el-menu-item index="adminTaskClassifies_1">
                    <router-link class="nav-item" to="/admin/train/classifies?type=1">训练分类管理</router-link>
                </el-menu-item>
                <el-menu-item index="adminTaskClassifies_2">
                    <router-link class="nav-item" to="/admin/task/classifies?type=2">任务分类管理</router-link>
                </el-menu-item>
                <el-menu-item index="adminTaskIndex">
                    <router-link class="nav-item" to="/admin/task/index">任务管理</router-link>
                </el-menu-item>

                <el-menu-item index="adminNewTaskIndex">
                    <router-link class="nav-item" to="/admin/newTask/index">任务中心</router-link>
                </el-menu-item>

                <el-menu-item index="adminCompanyTrainIndex">
                    <router-link class="nav-item" to="/admin/companyTraining/index">企业训练</router-link>
                </el-menu-item>

                <el-menu-item index="adminTeacherTrainIndex">
                    <router-link class="nav-item" to="/admin/teacherTraining/index">教师训练</router-link>
                </el-menu-item>
            </el-menu>
        </div>

        <router-view />
    </div>
</template>

<script>
export default {
    name: "AdminTaskLayout",
    data() {
        return {
            adminTab: "",
        };
    },

    watch: {
        "$route.name"(val) {
            // 企业训练
            if (["AdminCompanyTrainingRegister", "AdminCompanyTrainingPort", "AdminCompanyTrainingPortDetail"].includes(val)) {
                this.adminTab = "AdminCompanyTrainingIndex";
            }
        },
    },
    created() {
        if (this.$route.name === "adminTaskClassifies") {
            this.adminTab = `adminTaskClassifies_${this.$route.query.type}`;
        } else {
            this.adminTab = this.$route.name;
        }

        // console.log("tab: ", this.adminTab);
    },
};
</script>

<style scoped lang="scss">
.left-nav {
    .el-menu-item {
        padding: 0 !important;
        height: 46px;
        line-height: 46px;
        border-left: 2px solid transparent;
        .nav-item {
            padding: 0 20px;
            display: block;
            color: #333;
        }
        &.is-active {
            height: 46px;
            line-height: 46px;
            .nav-item {
                color: #1e34e4;
            }
        }
        &.is-active:after {
            position: absolute;
            content: "";
            height: 14px;
            width: 3px;
            background: #1e34e4;
            top: 16px;
        }
        &.el-menu-item:focus,
        &.el-menu-item:hover {
            outline: 0;
            background-color: transparent;
        }
    }
}
</style>
